import { selector } from 'recoil'
import { userAtom, authTokenAtom } from './atoms'

// ============================================
// Auth Selectors
// ============================================

export const isAuthenticatedSelector = selector({
  key: 'isAuthenticated',
  get: ({ get }) => {
    const user = get(userAtom)
    const token = get(authTokenAtom)
    return !!(user && token)
  },
})
